// @ts-nocheck
import React from 'react'
import {
    Grid,
    GridColumn,
    GridColumnMenuProps,
    GridColumnMenuItem,
    GridColumnMenuFilter,
} from '@progress/kendo-react-grid'

import { orderBy } from '@progress/kendo-data-query'

import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
    IntlService,
} from '@progress/kendo-react-intl'

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'

import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import esMessages from '../es.json'
import { process as kProcess } from '@progress/kendo-data-query'
import { Renderers } from './Renderers.jsx'
import './Grid.scss'
import orders from '../orders.json'
import { GridProps, GridItemChangeEvent } from '@progress/kendo-react-grid'
import { Popup, Offset } from '@progress/kendo-react-popup'
import { Menu, MenuItem } from '@progress/kendo-react-layout'

import AutoSizer from 'react-virtualized-auto-sizer'

// import PartTypeAhead from './PartTypeahead'
import { PartTypeahead, Checkbox, DQIDropDown, ImageComponent } from './GridComponents'
import { AttributeModal, ScrollDialog, ImageDialog } from './Modals'
import { parentPort } from 'worker_threads'
import { start } from 'repl'
import { getBaseURL } from '../../GlobalComponents/URLs'

load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
)

loadMessages(esMessages, 'es-ES')

const PART_SEARCH_URI = `${getBaseURL()}webapi/invtcategoryattribute/acParts/`
const PART_URL = `${getBaseURL()}webapi/inventory/parts/mktattributes`
const ATTRIBUTE_VALUE_URL = `${getBaseURL()}webapi/inventory/attributes`
const ATTRIBUTE_URL = `${getBaseURL()}webapi/inventory/attribute/`
const PART_IMAGE_URL = `${getBaseURL()}invtforms/invtimage.ashx?PartKey=`
const DQI_VALUES = ['', '1', '2', '3', '4', '5']
const MIN_COL_WIDTH = 100
// from SQL -- using js column names
const MAX_LENGTHS = {
    'Part Number': 28,
    ATTRIBUTE: 1500,
    Description: 255,
    Mkt: 1,
    Image: 10000000,
}

const locales = [
    {
        language: 'en-US',
        locale: 'en',
    },
    {
        language: 'es-ES',
        locale: 'es',
    },
]

const COMPONENT_FIELDS = {
    Image: true,
    'Web Enabled': true,
    'Data Quality Index': true,
}
const DATE_FORMAT = 'yyyy-mm-dd hh:mm:ss.SSS'
const intl = new IntlService('en-ES')

const wordToBoolean = (word: string | boolean) => {
    if (typeof word === 'boolean') return word
    let x = word.toLowerCase().trim()
    if (x === 'true') return true
    else if (x === 'false') return false
    else return undefined
}

// makes value copy paste friendly
const cleanValue = (str: string): string => {
    return str.replace(/\s+/g, ' ')
}

const parsePaste = (str: string) => {
    return str.split(/\r\n|\n|\r/).map((row) => row.split('\t'))
}

interface CFGridProps extends GridProps {
    renderers: any
    grid: any
    attributes: any
    partsRef: any
}

interface CFGridState {
    currentLocale: any
    dataState: any
    dataResult: any
    data: any
    skip?: any
    editField?: any
    changes?: any
    take?: any
    currentCategory: any
    currentModal?: any
    partNumbers: Object
    attributes: Array<any>
    mirrorPropsGrid: any
    mirrorPropsAttributes: any
    offset?: Offset
    open?: boolean
    selected?: any
    selecting: boolean
    floodFilling?: any
    contextField?: string
    sort?: any
}
interface ColumnMenuProps extends GridColumnMenuProps {
    onAddClick: any
    showDetails: boolean
    onDeleteClick: any
    onViewDetailsClick: any
}
class ColumnMenu extends React.Component<ColumnMenuProps, {}> {
    render() {
        return (
            <div>
                <GridColumnMenuItem onClick={this.props.onAddClick} title={'Add'} iconClass={''} />
                {this.props.showDetails && (
                    <GridColumnMenuItem
                        onClick={this.props.onViewDetailsClick}
                        title={'View Details'}
                        iconClass={''}
                    />
                )}
                {this.props.showDetails && (
                    <GridColumnMenuItem
                        onClick={this.props.onDeleteClick}
                        title={'Delete'}
                        iconClass={''}
                    />
                )}
            </div>
        )
        //this.props.showDetails &&
    }
}

export default class App extends React.Component<CFGridProps, CFGridState> {
    private renderers: any
    private compRef: any
    // ref to use when keyboard navigating around cells

    constructor(props) {
        super(props)
        const dataState = {
            skip: 0,
        }
        this.renderers = new Renderers(
            this.enterEdit,
            this.exitEdit,
            'inEdit',
            this.handleContextMenuOpen,
            this.onCellMouseDown,
            this.onCellMouseOver,
            this.onCellMouseUp,
            'selected'
        )
        let partNumbers = {}
        this.compRef = React.createRef()

        props.grid.map((row) => (partNumbers[row['Part Number']] = true))

        // need this field for when columns get reordered -- note not changing the object reference
        props.attributes.forEach((att, i) => (att.orderIndex = i))

        this.addColumn = this.addColumn.bind(this)
        this.loadPart = this.loadPart.bind(this)
        this.itemChange = this.itemChange.bind(this)
        this.addAttributes = this.addAttributes.bind(this)
        this.onAddClick = this.onAddClick.bind(this)
        this.handleCopy = this.handleCopy.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.enterEdit = this.enterEdit.bind(this)
        this.setRowLoading = this.setRowLoading.bind(this)
        this.onCellMouseUp = this.onCellMouseUp.bind(this)
        this.onCellMouseDown = this.onCellMouseDown.bind(this)
        this.onFloodFillEnd = this.onFloodFillEnd.bind(this)
        this.onFloodFillStart = this.onFloodFillStart.bind(this)
        this.copyColumn = this.copyColumn.bind(this)

        // this.handleContextMenuOpen = this.handleContextMenuOpen.bind(this)
        let grid = [...props.grid]
        if (grid[0] && grid[0]['Part Number']) {
            grid = [...grid, App.getEmptyRow(props)]
            grid[grid.length - 1].index = grid.length - 1
        } else {
            grid = [App.getEmptyRow(props)]
            grid[0].index = 0
        }
        let gridWithExtraRow = grid.map((row, i) => ({ ...row, index: i }))
        let sort: any = [{ field: 'ProductName', dir: 'asc' }]
        this.state = {
            data: gridWithExtraRow,
            dataResult: kProcess(gridWithExtraRow, dataState),
            dataState: dataState,
            currentLocale: locales[0],
            currentCategory: props.currentCategory,
            mirrorPropsGrid: props.grid,
            mirrorPropsAttributes: props.attributes,
            partNumbers: partNumbers,
            attributes: props.attributes,
            selecting: false,
            sort: sort,
        }
    }

    static getDerivedStateFromProps(props, current_state) {
        if (
            current_state.currentCategory !== props.currentCategory ||
            current_state.mirrorPropsGrid !== props.grid ||
            current_state.mirrorPropsAttributes !== props.attributes
        ) {
            let grid = props.grid.map((row, i) => ({ ...row, index: i }))

            if (grid[0] && grid[0]['Part Number']) {
                grid = [...grid, App.getEmptyRow(props)]
                grid[grid.length - 1].index = grid.length - 1
            } else {
                grid = [App.getEmptyRow(props)]
                grid[0].index = 0
            }
            let partNumbers = {}
            props.grid.forEach((element) => {
                partNumbers[element['Part Number']] = true
            })
            return {
                data: grid,
                attributes: props.attributes,
                dataResult: kProcess(orders, current_state.dataState),
                dataState: current_state.dataState,
                currentLocale: locales[0],
                currentCategory: props.currentCategory,
                mirrorPropsGrid: current_state.mirrorPropsGrid !== props.grid && props.grid,
                mirrorPropsAttributes:
                    current_state.mirrorPropsAttributes !== props.attributes && props.attributes,
                partNumbers: partNumbers,
            }
        }
        return null
    }

    componentDidUpdate() {}
    componentDidMount() {
        // for contextMenu click away
        document.addEventListener('click', () => {
            this.state.open && this.setState({ open: false })
        })

        document.addEventListener('mouseup', (event) => {
            // if (!((this.compRef && this.compRef.current && this.compRef.current.contains(event.target)) || (event.target["className"]  === 'awcgridcell') || ( event.target['parentElement'] && event.target['parentElement'].className === 'awcgridcell') || ( event.target['parentElement'] && event.target['parentElement']['parentElement'] && event.target['parentElement']['parentElement'].className === 'awcgridcell')
            // || ( event.target['parentElement'] && event.target['parentElement'].className.includes('k-popup')) || ( event.target['parentElement'] && event.target['parentElement']['parentElement'] && event.target['parentElement']['parentElement'].className === 'k-popup')
            // || (event.target['className'].includes && event.target['className'].includes('k-item')) || (event.target['className'].includes && event.target['className'].includes("k-columnmenu-item ")))) {
            //     let newData = this.state.data.map(row => ({...row, selected: false, selectedColumns: {}, inEdit: false}))
            //     this.setState({data: newData});
            // }
            if (
                this.compRef &&
                this.compRef.current &&
                !this.compRef.current.contains(event.target)
            ) {
                let currentTarget = event.target
                while (currentTarget['tagName'] !== 'BODY' && currentTarget['tagName'] !== 'HTML') {
                    if (currentTarget['className'].includes('k-animation-container')) return
                    if (!currentTarget['parentElement']) {
                        return
                    }
                    currentTarget = currentTarget['parentElement']
                }
                let newData = this.state.data.map((row) => ({
                    ...row,
                    selected: false,
                    selectedColumns: {},
                    inEdit: false,
                }))
                this.setState({ data: newData })
            }
        })
        // for copy and paste of grid
        document.addEventListener('copy', this.handleCopy as any)
        document.addEventListener('paste', this.handlePaste)
        document.addEventListener('keydown', this.handleKeyDown)
    }

    componentWillUnmount() {
        document.removeEventListener('copy', this.handleCopy as any)
        document.removeEventListener('paste', this.handlePaste)
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    onCellMouseDown = (e, dataItem, cellField) => {
        if (e.button === 2) return

        let start = { row: dataItem.index, column: cellField }
        let newSelected = { start, end: { ...start } }
        let newData = this.getSelectedData(this.state.data, newSelected)
        newData = newData.map((item) => ({ ...item, inEdit: undefined }))
        this.setState({ data: newData, selected: newSelected, selecting: true })
    }

    setRowLoading = (index, value, lastValidValue) => {
        let newData = this.state.data.map((row, i) => ({
            ...row,
            loading: i === index ? value : false,
            // clear out this field on end load
            'Part Number': index === i && lastValidValue ? lastValidValue : row['Part Number'],
        }))
        this.setState({ data: newData })
    }

    getSelectedData = (data, selected) => {
        // let viewData = this.getViewData()
        // let visibleParts = this.getViewVisiblePartNumbers()
        let { start, end } = selected
        let startIndex = Math.min(start.row, end.row)
        let startColumn = start.column
        let endIndex = Math.max(start.row, end.row)
        let endColumn = end.column
        let selectedColumns = {}
        let startAttribute = this.state.attributes.find((att) => att.Title === start.column)
        let endAttribute = this.state.attributes.find((att) => att.Title === end.column)
        let firstSelected = Math.min(startAttribute.orderIndex, endAttribute.orderIndex)
        let secondSelected = Math.max(startAttribute.orderIndex, endAttribute.orderIndex)

        this.state.attributes.forEach((att, j) => {
            if (att.orderIndex >= firstSelected && att.orderIndex <= secondSelected)
                selectedColumns[att.Title] = true
        })
        let newData = data.map((row, i) => ({
            ...row,
            selected: i >= startIndex && i <= endIndex,
            onlySelectedTentative:
                start.row === end.row && start.column === end.column && start.row === i,
            selectedColumns: selectedColumns,
        }))
        return newData
    }
    onCellMouseUp = (e, dataItem, cellField) => {
        if (e.button === 2) return
        e.stopPropagation()
        let noncopyableAttributes = ['Image', 'Web Enabled', 'Data Quality Index']
        if (this.state.floodFilling) {
            let newData = this.state.data.map((row, i) => {
                if (!row.selected) return row
                this.props.partsRef.current.changedParts[row['Part Number']] = true
                let newRow = { ...row }
                for (let key in row.selectedColumns) {
                    if (!noncopyableAttributes.includes(key)) {
                        newRow[key] = this.state.floodFilling
                    }
                }
                return newRow
            })
            this.props.partsRef.current.grid = newData
            this.setState({ floodFilling: '', selecting: false, data: newData })
            return
        }
        if (this.state.selecting) {
            e.preventDefault()
            e.stopPropagation()
            if (!this.state.selected) return
            let { start, end } = this.state.selected
            let onlySelected = start.row === end.row && start.column === end.column
            if (onlySelected) {
                if (dataItem.onlySelected === start.column) {
                    this.enterEdit(dataItem, end.column)
                    this.setState({ selecting: false })
                } else {
                    let newData = this.state.data.map((row, i) => ({
                        ...row,
                        onlySelected: i === dataItem.index ? start.column : false,
                    }))
                    this.setState({ data: newData, selecting: false })
                }
            } else {
                this.setState({ selecting: false })
            }
        } else {
            this.setState({ selecting: false })
        }
    }

    onCellMouseOver = (e, dataItem, cellField) => {
        if (e.button === 2) return
        let { selected, selecting } = this.state
        if (
            selected &&
            selecting &&
            (selected.end.row !== dataItem.index || selected.end.column !== cellField)
        ) {
            let end = { row: dataItem.index, column: cellField }
            selected.end = end
            // let data = this.getViewData()
            let newData = this.getSelectedData(this.state.data, selected)
            this.setState({ selected, data: newData })
        }
    }

    selectAll = () => {
        let { attributes, data } = this.state
        let newSelected = {
            start: {
                row: 0,
                column: attributes[0].Title,
            },
            end: {
                row: data.length - 1,
                column: attributes[attributes.length - 1].Title,
            },
        }
        let newSelectedData = this.getSelectedData(data, newSelected)
        this.setState({ selected: newSelected, data: newSelectedData })
    }

    //technically select column and copy
    copyColumn = (field) => {
        let { attributes, data } = this.state
        let newSelected = {
            start: {
                row: 0,
                column: field,
            },
            end: {
                row: data.length - 1,
                column: field,
            },
        }
        let newSelectedData = this.getSelectedData(data, newSelected)
        this.setState({ selected: newSelected, data: newSelectedData }, () =>
            document.execCommand('copy')
        )
    }

    handleKeyDown = (e: KeyboardEvent) => {
        //@ts-ignore see External and web modal
        if (window.inModal) return
        if (e.key === 'Control') {
            return
        }
        if (e.key === 'Shift') {
            return
        }
        if (e.key === 'a') {
            if (e.ctrlKey) {
                e.preventDefault()
                this.selectAll()
                return
            }
        }
        if (e.key === 'v') {
            if (e.ctrlKey) {
                return
            }
        }
        if (e.key === 'c') {
            if (e.ctrlKey) {
                return
            }
        }
        if (e.key === 'Delete' || e.key === 'Backspace') {
            let { selected, attributes, data } = this.state
            if (selected) {
                if (data[selected.start.row].inEdit) return
                this.deleteSelection()
                return
            }
        }
        if (e.key === 'Enter') {
            let { selected, attributes, data } = this.state
            if (
                selected &&
                selected.start.row === selected.end.row &&
                selected.start.column === selected.end.column
            ) {
                if (!data[selected.start.row].inEdit) return
                e.preventDefault()
                if (selected.start.row + 1 < data.length) {
                    let newSelected = {
                        start: {
                            row: selected.start.row + 1,
                            column: selected.start.column,
                        },
                        end: {
                            row: selected.start.row + 1,
                            column: selected.start.column,
                        },
                    }
                    let newSelectedData = this.getSelectedData(data, newSelected)
                    //move inEdit field
                    newSelectedData[selected.start.row].inEdit = undefined
                    newSelectedData[newSelected.start.row].inEdit = newSelected.start.column
                    this.setState({ selected: newSelected, data: newSelectedData })
                }
            }
            return
        }
        if (e.key === 'z') {
            if (e.ctrlKey) {
                e.preventDefault()
                // let selected = this.state.selected
                // let data= this.state.data.map((item, i) => {
                //   if(item.inEdit){
                //     // need to add this so if validation is bad it can jump back to it since we forced bad data in
                //     let lastValidValue = item.lastValidValue
                //     return { ...item, [event.field]: event.value, lastValidValue }
                //   }
                //   else
                //     return item
                //   });

                return
            }
        }
        if (e.key === 'Escape') {
            let newData = this.state.data.map((row) => ({
                ...row,
                selected: false,
                selectedColumns: {},
                inEdit: false,
            }))
            this.setState({ data: newData })
            return
        }
        if (e.key === 'Enter') {
            let newData = this.state.data.map((row) => ({
                ...row,
                selected: false,
                selectedColumns: {},
                inEdit: false,
            }))
            this.setState({ data: newData })
            return
        }
        if (e.code === 'Tab') {
            e.preventDefault()
            let { selected, attributes, data } = this.state
            if (
                selected &&
                selected.start.row === selected.end.row &&
                selected.start.column === selected.end.column
            ) {
                let attributeCount = attributes.length
                let nextColumn
                // backwards tabbing to go left
                if (e.shiftKey) {
                    nextColumn = attributes.findIndex((x) => x.Title === selected.start.column) - 1
                    if (nextColumn === -2) {
                        return
                    }
                    // just exit if invalid
                    if (nextColumn < 0) return
                } else {
                    nextColumn = attributes.findIndex((x) => x.Title === selected.start.column) + 1
                    if (nextColumn === 0) {
                        return
                    }
                    if (nextColumn >= attributeCount) {
                        return
                    }
                }

                let newSelected = {
                    start: {
                        row: selected.start.row,
                        column: attributes[nextColumn].Title,
                    },
                    end: {
                        row: selected.start.row,
                        column: attributes[nextColumn].Title,
                    },
                }
                let newSelectedData = this.getSelectedData(data, newSelected)
                //move inEdit field
                if (newSelectedData[newSelected.start.row].inEdit === selected.start.column)
                    newSelectedData[newSelected.start.row].inEdit = newSelected.start.column
                this.setState({ selected: newSelected, data: newSelectedData })
            }
        } else if (e.code === 'ArrowDown') {
            let { selected, attributes, data } = this.state
            if (
                selected &&
                selected.start.row === selected.end.row &&
                selected.start.column === selected.end.column
            ) {
                if (data[selected.start.row].inEdit) return
                e.preventDefault()
                if (selected.start.row + 1 < data.length) {
                    let newSelected = {
                        start: {
                            row: selected.start.row + 1,
                            column: selected.start.column,
                        },
                        end: {
                            row: selected.start.row + 1,
                            column: selected.start.column,
                        },
                    }
                    let newSelectedData = this.getSelectedData(data, newSelected)
                    //move inEdit field
                    // if(newSelectedData[newSelected.start.row].inEdit === selected.start.column)
                    //     newSelectedData[newSelected.start.row].inEdit = newSelected.start.column
                    this.setState({ selected: newSelected, data: newSelectedData })
                }
            }
        } else if (e.code === 'ArrowUp') {
            let { selected, attributes, data } = this.state
            if (
                selected &&
                selected.start.row === selected.end.row &&
                selected.start.column === selected.end.column
            ) {
                if (data[selected.start.row].inEdit) return
                e.preventDefault()
                if (selected.start.row > 0) {
                    let newSelected = {
                        start: {
                            row: selected.start.row - 1,
                            column: selected.start.column,
                        },
                        end: {
                            row: selected.start.row - 1,
                            column: selected.start.column,
                        },
                    }
                    let newSelectedData = this.getSelectedData(data, newSelected)
                    //move inEdit field
                    // if(newSelectedData[newSelected.start.row].inEdit === selected.start.column)
                    //     newSelectedData[newSelected.start.row].inEdit = newSelected.start.column
                    this.setState({ selected: newSelected, data: newSelectedData })
                }
            }
        } else if (e.code === 'ArrowLeft') {
            let { selected, attributes, data } = this.state
            if (
                selected &&
                selected.start.row === selected.end.row &&
                selected.start.column === selected.end.column
            ) {
                if (data[selected.start.row].inEdit) return
                e.preventDefault()
                let attributeCount = attributes.length
                let prevColumn = attributes.findIndex((x) => x.Title === selected.start.column) - 1
                if (prevColumn === -2) {
                    return
                }
                if (prevColumn > -1) {
                    let newSelected = {
                        start: {
                            row: selected.start.row,
                            column: attributes[prevColumn].Title,
                        },
                        end: {
                            row: selected.start.row,
                            column: attributes[prevColumn].Title,
                        },
                    }
                    let newSelectedData = this.getSelectedData(data, newSelected)
                    //move inEdit field
                    // if(newSelectedData[newSelected.start.row].inEdit === selected.start.column)
                    //     newSelectedData[newSelected.start.row].inEdit = newSelected.start.column
                    this.setState({ selected: newSelected, data: newSelectedData })
                }
            }
        } else if (e.code === 'ArrowRight') {
            let { selected, attributes, data } = this.state
            if (
                selected &&
                selected.start.row === selected.end.row &&
                selected.start.column === selected.end.column
            ) {
                if (data[selected.start.row].inEdit) return
                e.preventDefault()
                let attributeCount = attributes.length
                let nextColumn = attributes.findIndex((x) => x.Title === selected.start.column) + 1
                if (nextColumn === 0) {
                    return
                }
                if (nextColumn < attributeCount) {
                    let newSelected = {
                        start: {
                            row: selected.start.row,
                            column: attributes[nextColumn].Title,
                        },
                        end: {
                            row: selected.start.row,
                            column: attributes[nextColumn].Title,
                        },
                    }
                    let newSelectedData = this.getSelectedData(data, newSelected)
                    //move inEdit field
                    // if(newSelectedData[newSelected.start.row].inEdit === selected.start.column)
                    //     newSelectedData[newSelected.start.row].inEdit = newSelected.start.column
                    this.setState({ selected: newSelected, data: newSelectedData })
                }
            }
        } else {
            let { selected, attributes, data } = this.state
            if (
                selected &&
                selected.start.row === selected.end.row &&
                selected.start.column === selected.end.column
            ) {
                if (data[selected.start.row].inEdit) return
                e.preventDefault()
                let newData = data.map((row, i) =>
                    i === selected.start.row
                        ? { ...row, inEdit: selected.start.column }
                        : { ...row, inEdit: false }
                )
                this.setState({ data: newData })
                //behavior for noncomponent fields -- do item change event for first press
                if (!COMPONENT_FIELDS[selected.start.column] && /^[a-z0-9]$/i.test(e.key)) {
                    let fakeEvent = {
                        field: selected.start.column,
                        value: e.key,
                        dataItem: newData[selected.start.row],
                    }
                    this.itemChange(fakeEvent as GridItemChangeEvent, true)
                }
            }
        }
    }
    onFloodFillStart = (dataItem, cellField) => {
        this.setState({ floodFilling: dataItem[cellField], selecting: true })
    }

    onFloodFillEnd = () => {
        this.setState({ floodFilling: '', selecting: false })
    }

    handleCopy = (e) => {
        const inEdit = this.state.data.some((row) => row.inEdit)
        if (inEdit) {
            return
        }
        let myWindow = window as any

        e.preventDefault && e.preventDefault()
        let { selected } = this.state
        let attributesInRange
        if (selected) {
            let selectedAttributes = { ...this.state.data[0].selectedColumns }
            selectedAttributes['Part Number'] = true
            attributesInRange = Object.keys(selectedAttributes)
        } else {
            attributesInRange = this.state.attributes.map((att) => att.Title)
        }
        let rowsSelected

        if (selected) {
            rowsSelected = this.state.data.slice(selected.start.row, selected.end.row + 1)
        } else {
            rowsSelected = this.state.data
        }
        let noncopyableAttributes = ['Image']
        let copyableAttributes = attributesInRange.filter(
            (att) => !noncopyableAttributes.includes(att)
        )
        const header = copyableAttributes.join('\t')
        const rows = rowsSelected.map((row) =>
            copyableAttributes
                .map((att) => {
                    return cleanValue(row[att].toString())
                })
                .join('\t')
        )
        const text = [header, ...rows].join('\n')
        if (myWindow.clipboardData && myWindow.clipboardData.setData) {
            myWindow.clipboardData.setData('Text', text)
        } else {
            e.clipboardData.setData('text/plain', text)
        }
    }

    //   getChangesFromPaste (parseData) {
    //     const changes = []
    //     const additions = []
    //     const nonPastables = ["Web Enabled", "Image", "Data Quality Index"]
    //     //verify columns
    //     if(parseData.length>0){
    //       // right amount of colums
    //       // if(parsedText[0].length !== this.state.columns.length){
    //       //   return []
    //       // }
    //       let attributesToAdd = {}
    //       let tablePaste = true
    //       let data = this.state.viewGrid
    //       let parsedPartNumberColumnIndex = -1
    //       for(let i=0;i<parseData[0].length; i++){
    //         let partNumberColumnIndex = parseData[0].findIndex(x=> x === "Part Number")
    //         // column is really a column
    //         if (partNumberColumnIndex === -1){
    //           tablePaste = false
    //         }
    //         else{
    //           parsedPartNumberColumnIndex = partNumberColumnIndex
    //         }
    //       }

    //       if(!tablePaste){
    //         let { start, end } = this.state.selected;
    //         parseData.forEach((row, i) => {
    //           row.forEach((value, j) => {
    //             end = { i: start.i + i, j: start.j + j };
    //             const cell = data[end.i] && data[end.i][end.j];
    //             if (!cell) {
    //               additions.push({ key:`${i}-${j}`, row: end.i, col: end.j, value });
    //             } else if (!cell.readOnly) {
    //               changes.push({ cell, row: end.i, col: end.j, value });
    //             }
    //           });
    //         });
    //       }
    //       else{
    //         let parseToGrid = {}
    //         let maxColumnIndex = this.state.columns.length - 1
    //         let maxRowIndex = data.length - 1
    //         let maxLengths = {}
    //         for(let i=0;i<parseData[0].length; i++){
    //           let parseColumnIndex =  this.state.columns.findIndex(x=> x.label === parseData[0][i])
    //           // not a current column
    //           if (parseColumnIndex === -1){
    //             attributesToAdd[i] = parseData[0][i]
    //             maxColumnIndex += 1
    //             parseToGrid[i] = maxColumnIndex
    //             maxLengths[i] = parseData[0][i].length
    //           }
    //           else{
    //             parseToGrid[i] = parseColumnIndex
    //           }

    //         }

    //         let gridPartNumberColumnIndex = this.state.columns.findIndex(x=> x.label === "Part Number")
    //         for(let k=1;k<parseData.length; k++){
    //           let rowIndex = data.findIndex(x=>x[gridPartNumberColumnIndex].value === parseData[k][parsedPartNumberColumnIndex])
    //           if(rowIndex === -1){
    //             maxRowIndex += 1
    //             rowIndex = maxRowIndex
    //           }

    //           for(let i=0;i<parseData[0].length; i++){
    //             let value = parseData[k][i]

    //             if(parseData[0][i] === "Image"){
    //               continue
    //             }
    //             if(parseData[0][i] === "Web Enabled"){
    //               if(value.toLowerCase().trim() === "true")
    //                 value = true
    //               else if(value.toLowerCase().trim() === "false")
    //                 value = false
    //               else
    //                 continue
    //             }
    //             if(parseData[0][i] === "Data Quality Index"){
    //               if(!DQI_VALUES.includes(value.trim()))
    //                 continue
    //             }
    //             let columnIndex = parseToGrid[i]
    //             maxLengths[i] = value.length > maxLengths[i] ? value.length : maxLengths[i]
    //             const cell = data[rowIndex] && data[rowIndex][columnIndex];
    //             if (!cell) {
    //               additions.push({key:`${rowIndex}-${columnIndex}`, row: rowIndex, col: columnIndex, value });
    //             } else if (!cell.readOnly) {
    //               changes.push({ cell, row: rowIndex, col: columnIndex, value });
    //             }
    //           }
    //         }
    //         let addArray = Object.keys(attributesToAdd).map(index => ({Title: attributesToAdd[index], width: maxLengths[index] * 10}))
    //         this.addAttributes(addArray)
    //       }
    //     }
    //     return {additions, changes}
    //   }

    async handlePaste(e) {
        if (this.state.data.some((row) => row['inEdit'])) return
        let myWindow = window as any
        let pasteData = []
        let attributesToAdd = []
        if (myWindow.clipboardData && myWindow.clipboardData.getData) {
            // IE
            pasteData = parsePaste(myWindow.clipboardData.getData('Text'))
        } else if (e.clipboardData && e.clipboardData.getData) {
            pasteData = parsePaste(e.clipboardData.getData('text/plain'))
        }
        if (pasteData.length > 0) {
            let pastedAttributesMapping = {}
            let partNumberColumn = pasteData[0].findIndex((attName) => attName === 'Part Number')
            if (partNumberColumn < 0) return
            pasteData[0].forEach((attName, i) => {
                if (this.state.attributes.find((att) => att.Title === attName))
                    pastedAttributesMapping[i] = attName
                else attributesToAdd.push(attName)
            })
            let { data } = this.state
            let partsToLoad = []
            let errorString = ''
            pasteData.forEach((row, i) => {
                if (i === 0) return
                let existingRowIndex = this.state.data.findIndex(
                    (drow) => drow['Part Number'] === row[partNumberColumn]
                )
                if (existingRowIndex > -1) {
                    let newRow
                    this.props.partsRef.current.changedParts[row[partNumberColumn]] = true
                    row.forEach((value, j) => {
                        // ignore header row
                        if (pastedAttributesMapping[j]) {
                            data[existingRowIndex][pastedAttributesMapping[j]] =
                                pastedAttributesMapping[j] === 'Web Enabled'
                                    ? wordToBoolean(value)
                                    : value
                        }
                    })
                } else {
                    partsToLoad.push(row[partNumberColumn])
                }
            })
            this.props.partsRef.current.grid = data
            this.addAttributes(attributesToAdd)

            let newPartPromises = await Promise.all(
                partsToLoad.map((newPart) =>
                    newPart.trim() === '' ? Promise.resolve(false) : this.loadPart(newPart)
                )
            )
            newPartPromises.forEach((newPartPromise, i) => {
                if (newPartPromise) data.push(newPartPromise)
            })
            data = data.filter((row) => row['Part Number'].trim() !== '')
            data = [...data, App.getEmptyRow(this.props, this.state)]
            data = data.map((row, i) => ({ ...row, index: i }))
            this.setState({ data: data })
        }
    }

    addAttributes = (attributesToAdd) => {
        if (attributesToAdd.length === 0) {
            this.setState({ currentModal: null })
            return
        } else {
            let [newAttribute, ...remainingAttributes] = attributesToAdd
            let defaultAttribute = {
                Title: newAttribute,
                Hidden: false,
                Type: 'String',
                ExcelFilter: false,
                DocMap: '',
                Validation: '',
            }

            let request_url = `${ATTRIBUTE_URL}/${newAttribute}`
            fetch(request_url, {
                credentials: 'include',
            })
                .then((resp) => {
                    // brand new
                    if (resp.status === 204) {
                        return defaultAttribute
                    }
                    if (resp.status === 200) {
                        return resp.json()
                    }
                })
                .then((json) => {
                    if (json) {
                        // remove any extra unexpected fields
                        for (let key in json) {
                            if (!Object.keys(defaultAttribute).includes(key) && key !== 'Item') {
                                delete json[key]
                            }
                        }
                        //default these for category
                        json.DocMap = ''
                        json.Validation = ''
                        json.Hidden = false
                        if (json.Item) {
                            let originalAttribute = JSON.parse(JSON.stringify(json))
                            json.originalAttribute = originalAttribute
                        } else {
                            json.originalAttribute = {}
                        }
                        json.width = newAttribute.width
                        this.setState({
                            currentModal: (
                                <AttributeModal
                                    attribute={json}
                                    submitText='Add'
                                    currentAttributes={this.state.attributes}
                                    titleEditable={false}
                                    close={() => this.setState({ currentModal: null })}
                                    submit={(attInfo) => {
                                        this.addColumn(attInfo)
                                        this.addAttributes(remainingAttributes)
                                    }}
                                />
                            ),
                        })
                    }
                })
        }
    }

    handleContextMenuOpen = (e, dataItem, cellField) => {
        // this.dataItem = dataItem;
        // this.dataItemIndex = this.state.gridData.findIndex(p => (p.ProductID === this.dataItem.ProductID));
        let newData = this.state.data.map((row) => ({ ...row, inEdit: undefined }))
        e.preventDefault()
        let offset = { left: e.clientX, top: e.clientY }
        this.setState({
            open: true,
            offset,
            data: newData,
            contextField: cellField,
            selected: null,
        })
    }

    handleOnSelect = (e) => {
        switch (e.item.text) {
            case 'Copy Selection':
                document.execCommand('copy')
                break
            case 'Select Whole Table':
                this.selectAll()
                break
            case 'Copy Column':
                this.copyColumn(this.state.contextField)
                break
            default:
                break
        }
    }

    // static so can be called from constructor. pass props since can't use this in static
    static getEmptyRow = (props, state?) => {
        let source = state || props
        let emptyRow: any = {}
        source.attributes.forEach(
            (att) => (emptyRow[att.Title] = att.Title === 'Web Enabled' ? false : '')
        )
        let sourceGrid = state ? 'data' : 'grid'
        emptyRow.index = source[sourceGrid].length
        return emptyRow
    }

    dataStateChange = (event) => {
        this.setState({
            dataResult: kProcess(this.state.data, event.data),
            // viewData: [...orderBy(kProcess(this.state.data.slice(0, this.state.data.length-1), event.data).data, this.state.sort)].map((r, i) => ({...r, viewIndex: i})),
            dataState: event.data,
        })
    }

    getViewDetailsOnClick = (attribute) => {
        let pattribute = { ...attribute, originalAttribute: { ...attribute } }
        return () => {
            this.setState({
                currentModal: (
                    <AttributeModal
                        attribute={pattribute}
                        currentAttributes={this.state.attributes}
                        titleEditable={false}
                        close={() => this.setState({ currentModal: null })}
                        submit={(attInfo) => {
                            this.props.partsRef.current.attributes.push({
                                state: 'CHANGED',
                                ...attInfo,
                            })
                            this.props.handleCatSave(attInfo.originalAttribute.CategoryId)
                            this.setState({ currentModal: null })
                        }}
                    />
                ),
            }) //this.addColumn(attInfo)
        }
    }

    onAddClick() {
        this.setState({
            currentModal: (
                <AttributeModal
                    attribute={null}
                    submitText='Add'
                    currentAttributes={this.state.attributes}
                    titleEditable={true}
                    close={() => this.setState({ currentModal: null })}
                    submit={(attInfo) => {
                        this.addColumn(attInfo)
                        this.setState({ currentModal: null })
                    }}
                />
            ),
        })
    }

    deleteColumn = (attribute) => {
        this.props.partsRef.current.attributes.push({
            state: 'DELETED',
            ...attribute,
        })
        let removeIndex = this.state.attributes.findIndex((x) => x.Item === attribute.Item)
        if (removeIndex === -1) {
            alert('bad delete')
            return
        }
        let newAttributes = this.state.attributes
        newAttributes.splice(removeIndex, 1)

        this.setState({ attributes: [...newAttributes] })
    }

    getOrderedSelected = () => {
        let { selected, attributes } = this.state
        if (!selected) return selected
        let realStartRowIndex = Math.min(selected.start.row, selected.end.row)
        let realEndRowIndex = Math.max(selected.start.row, selected.end.row)
        let startColumnIndex = attributes.findIndex((att) => att.Title === selected.start.column)
        let endColumnIndex = attributes.findIndex((att) => att.Title === selected.end.column)
        if (startColumnIndex === -1 || endColumnIndex === -1) {
            return
        }
        let realStartColumn =
            startColumnIndex < endColumnIndex ? selected.start.column : selected.end.column
        let realEndColumn =
            startColumnIndex > endColumnIndex ? selected.start.column : selected.end.column

        return {
            start: { row: realStartRowIndex, column: realStartColumn },
            end: { row: realEndRowIndex, column: realEndColumn },
        }
    }

    getViewData = () => {
        return orderBy(kProcess(this.state.data, this.state.dataState).data, this.state.sort)
    }
    getViewVisiblePartNumbers = () => {
        let map = {}
        let data = this.getViewData()
        data.forEach((row) => (map[row['Part Number']] = true))
        return map
    }
    deleteSelection = () => {
        let { data } = this.state
        let selected = this.getOrderedSelected()
        let attributesInRange
        let selectedAttributesMap
        if (selected) {
            selectedAttributesMap = { ...this.state.data[0].selectedColumns }
            attributesInRange = Object.keys(selectedAttributesMap)
        } else {
            return
        }

        let newData
        let newPartsChanged = []
        if (selectedAttributesMap['Part Number']) {
            let removedParts = []
            newData = [...data]
            // remove all viewable selected
            data.forEach((index) => {
                if (index >= selected.start.row && index <= selected.end.row) {
                    removedParts.push({ ...newData[index] })
                    delete newData[index]
                }
            })
            removedParts.forEach((row) => {
                newPartsChanged.push(row['Part Number'])
            })
            newData = newData.map((row, i) => ({ ...row, index: i }))
        } else {
            newData = data.map((row, i) => {
                if (i < selected.start.row || i > selected.end.row) return row
                newPartsChanged.push(row['Part Number'])
                let newRow = { ...row }
                attributesInRange.forEach((att) => {
                    if (att === 'Image') {
                    } else if (att === 'Web Enabled') {
                        newRow[att] = false
                    } else {
                        newRow[att] = ''
                    }
                })
                return newRow
            })
        }
        newPartsChanged.forEach((partNumber) => {
            this.props.partsRef.current.changedParts[partNumber] = true
        })
        this.setState({ data: newData, selected: undefined })
    }

    addColumn(attributeInfo) {
        const attributes = [...this.state.attributes]
        let { data } = this.state
        attributeInfo.GridColumn = attributes.length
        if (attributeInfo.Item) {
            let url = `${ATTRIBUTE_VALUE_URL}/${attributeInfo.Item}`
            fetch(url, {
                credentials: 'include',
            })
                .then((resp) => {
                    if (resp.ok) {
                        if (resp.status === 204) {
                            return { Attributes: [] }
                        }
                        return resp.json()
                    } else {
                        throw new Error("Didn't Get json")
                    }
                })
                .then((json) => {
                    let map = {}
                    json.Attributes.forEach((ele) => {
                        map[ele.PartNumber] = ele.AttributeValue
                    })
                    // technically this data should already be here but it could have been altered
                    data = this.state.data.map((r, i) => {
                        const row = { ...r }
                        let attributeValue = map[row['Part Number']] || ''
                        row[attributeInfo.Title] = attributeValue
                        return row
                    })

                    this.props.partsRef.current.attributes.push({
                        state: 'ADDED',
                        ...attributeInfo,
                    })
                    attributes.push({ ...attributeInfo })
                    this.props.partsRef.current.grid = data
                    this.props.partsRef.current.columns = attributes
                    this.setState({ data, attributes })
                })
            // .catch((e) => {
            //     console('error in attribute backfill', e)
            // })
        } else {
            let minKey = 0
            attributes.forEach((ele) => {
                if (ele.Item && ele.Item < minKey) {
                    minKey = ele.Item
                }
            })
            let newKey = minKey - 1
            attributeInfo.Item = newKey
            data = this.state.data.map((r, i) => {
                r[attributeInfo.Title] = ''
                return r
            })
            this.props.partsRef.current.grid = data
            this.props.partsRef.current.attributes.push({
                state: 'ADDED',
                ...attributeInfo,
            })
            this.props.partsRef.current.columns = attributes
            attributes.push({ ...attributeInfo })
            this.setState({ data, attributes })
        }
    }

    expandChange = (event) => {
        const isExpanded =
            event.dataItem.expanded === undefined
                ? event.dataItem.aggregates
                : event.dataItem.expanded
        event.dataItem.expanded = !isExpanded

        this.setState({ ...this.state })
    }

    getGridColumn = (attribute) => {
        const renderGridColumnMenu = (props) => {
            const showDetails = attribute.item !== -1
            if (this.state.selected) this.setState({ selected: false })
            return (
                <>
                    <ColumnMenu
                        {...props}
                        columns={this.state.attributes}
                        attribute={attribute}
                        showDetails={showDetails}
                        onViewDetailsClick={this.getViewDetailsOnClick(attribute)}
                        onAddClick={this.onAddClick}
                        onDeleteClick={() => {
                            this.deleteColumn(attribute)
                            props.onCloseMenu()
                        }}
                        key={Math.random()}
                    />
                    {/* <GridColumnMenuFilter {...props} /> */}
                </>
            )
        }
        switch (attribute.Title) {
            case 'Part Number':
                return (
                    <GridColumn
                        cell={PartTypeahead}
                        key={Math.random()}
                        field={attribute.Title}
                        editable={true}
                        editor={'text'}
                        width='450px'
                        resizable={true}
                        // key={attribute.Title}
                        columnMenu={renderGridColumnMenu}
                    />
                )
            case 'Web Enabled':
                return (
                    <GridColumn
                        cell={Checkbox}
                        key={Math.random()}
                        field={attribute.Title}
                        editable={true}
                        editor={'text'}
                        width='130px'
                        resizable={true}
                        columnMenu={renderGridColumnMenu}
                    />
                )
            case 'Data Quality Index':
                return (
                    <GridColumn
                        // cell={DQIDropDown}
                        title={'DQI'}
                        key={Math.random()}
                        field={attribute.Title}
                        editable={true}
                        editor={'text'}
                        width='80px'
                        resizable={true}
                        columnMenu={renderGridColumnMenu}
                    />
                )
            case 'Image':
                return (
                    <GridColumn
                        cell={ImageComponent}
                        key={Math.random()}
                        field={attribute.Title}
                        editable={false}
                        editor={'text'}
                        width='80px'
                        resizable={true}
                        // key={attribute.Title}
                        columnMenu={renderGridColumnMenu}
                    />
                )
            case 'Mkt':
                return (
                    <GridColumn
                        field={attribute.Title}
                        key={Math.random()}
                        editable={true}
                        editor={'text'}
                        width='80px'
                        resizable={true}
                        // key={attribute.Title}
                        columnMenu={renderGridColumnMenu}
                    />
                )
            default:
                return (
                    <GridColumn
                        field={attribute.Title}
                        key={Math.random()}
                        editable={true}
                        editor={'text'}
                        filter={'text'}
                        width='190px'
                        resizable={true}
                        // key={attribute.Title}
                        columnMenu={renderGridColumnMenu}
                    />
                )
        }
    }

    _pdfExport
    exportExcel = () => {
        this._export.save()
    }

    _export
    exportPDF = () => {
        this._pdfExport.save()
    }

    shouldComponentUpdate() {
        return true
    }

    render() {
        return (
            <AutoSizer>
                {({ width, height }) => {
                    return (
                        <LocalizationProvider language={this.state.currentLocale.language}>
                            <IntlProvider locale={this.state.currentLocale.locale}>
                                <div ref={this.compRef}>
                                    <Grid
                                        style={{
                                            height: height,
                                            width: width,
                                            overflowY: 'hidden',
                                        }}
                                        className='categoryFormsGrid'
                                        // columnVirtualization={true}
                                        scrollable='virtual'
                                        // sortable
                                        // filterable
                                        // groupable
                                        reorderable
                                        resizable
                                        cellRender={this.renderers.cellRender}
                                        rowRender={this.renderers.rowRender}
                                        pageable={false}
                                        pageSize={40}
                                        total={this.state.data.length}
                                        data={[
                                            ...this.state.data
                                                .slice(0, this.state.data.length - 1)
                                                .slice(
                                                    this.state.dataState.skip,
                                                    this.state.dataState.skip + 40
                                                ),
                                            this.state.data[this.state.data.length - 1],
                                        ].map((r, index) => ({
                                            ...r,
                                            floodFilling: this.state.floodFilling,
                                            setRowLoading: this.setRowLoading,
                                            onMouseDown: this.onCellMouseDown,
                                            onMouseOver: this.onCellMouseOver,
                                            onMouseUp: this.onCellMouseUp,
                                            onFloodFillStart: this.onFloodFillStart,
                                            onFloodFillEnd: this.onFloodFillEnd,
                                            handleContextMenu: this.handleContextMenuOpen,
                                            partNumbers: this.state.partNumbers,
                                        }))}
                                        {...this.state.dataState}
                                        onDataStateChange={this.dataStateChange}
                                        // sort={this.state.sort}
                                        onSortChange={(e) => {
                                            this.setState({
                                                sort: e.sort,
                                                // viewData: [...orderBy(kProcess(this.state.data.slice(0, this.state.data.length-1), this.state.dataState).data, e.sort)].map((r, i) => ({...r, viewIndex: i})),
                                            })
                                        }}
                                        //
                                        // detail={DetailComponent}
                                        onItemChange={this.itemChange}
                                        editField='inEdit'
                                        expandField='expanded'
                                        onExpandChange={this.expandChange}
                                        onPageChange={this.pageChange}
                                        rowHeight={30}
                                        onColumnReorder={(event) => {
                                            let newAttributes = this.state.attributes
                                            this.props.partsRef.current.columns =
                                                this.state.attributes
                                            event.columns.forEach((col) => {
                                                let attribute = newAttributes.find(
                                                    (att) => att.Title === col.field
                                                )
                                                attribute.orderIndex = col.orderIndex
                                            })
                                            this.setState({ attributes: newAttributes })
                                        }}
                                    >
                                        {this.state.attributes.map((att) =>
                                            this.getGridColumn(att)
                                        )}
                                    </Grid>
                                    {this.state.currentModal}
                                </div>
                                <Popup
                                    offset={this.state.offset}
                                    show={this.state.open}
                                    // open={this.onPopupOpen}
                                    popupClass={'popup-content'}
                                >
                                    <div
                                    // onFocus={this.onFocusHandler}
                                    // onBlur={this.onBlurHandler}
                                    // tabIndex={-1}
                                    // ref={el => (this.menuWrapperRef = el)}
                                    >
                                        <Menu
                                            vertical={true}
                                            style={{ display: 'inline-block' }}
                                            onSelect={this.handleOnSelect}
                                        >
                                            <MenuItem text='Copy Selection' />
                                            <MenuItem text='Select Whole Table' />
                                            <MenuItem text='Copy Column' />
                                        </Menu>
                                    </div>
                                </Popup>
                            </IntlProvider>
                        </LocalizationProvider>
                    )
                }}
            </AutoSizer>
        )
    }

    enterEdit = (dataItem, field) => {
        const data = this.state.data.map((item) => ({
            ...item,
            inEdit: item['Part Number'] === dataItem['Part Number'] ? field : undefined,
        }))

        this.setState({
            data,
        })
    }

    exitEdit = () => {
        const data = this.state.data.map((item) => ({
            ...item,
            inEdit: undefined,
        }))

        this.setState({
            data,
        })
    }

    saveChanges = () => {
        this.props.grid.splice(0, this.props.grid.length, ...this.state.data)
        this.setState({
            editField: undefined,
            changes: false,
        })
    }

    loadPart(partNumber) {
        return fetch(`${PART_URL}/${partNumber}`, {
            credentials: 'include',
        })
            .then((resp) => {
                if (!resp.ok) {
                    return false
                }
                if (resp.status === 204) {
                    return { Attributes: [] }
                }
                return resp.json()
            })
            .then((json): any => {
                if (!json) {
                    alert(`Part ${partNumber} not found`)
                    return Promise.resolve(false)
                }

                let row = { 'Part Number': partNumber }
                json.Attributes.map((att) => {
                    let newValue = att.AttributeValue
                    if (att.Title === 'Web Enabled' || att.Title === 'Image')
                        newValue = wordToBoolean(newValue)
                    row[att.Title] = newValue
                })
                this.props.partsRef.current.loadedParts[partNumber] = json.Attributes
                this.props.partsRef.current.changedParts[partNumber] = true
                return row
                // this.setState({partNumbers: newPartNumbers})
            })
            .catch((e) => {
                console.warn('Fetch part bad', e)
            })
    }

    itemChange = async (event: GridItemChangeEvent, forced) => {
        const inEditID = event.dataItem['Part Number']
        let data
        let initData = JSON.parse(JSON.stringify(this.state.data))
        let rowIndex = this.state.data.findIndex((row) => row['Part Number'] === inEditID)
        if (event.field === 'Part Number') {
            if (event.value.trim().length === 0) {
                data = this.state.data
                    .filter((item) => {
                        return item['Part Number'] !== inEditID
                    })
                    .map((row, i) => ({ ...row, index: i }))
            } else {
                data = this.state.data
                if (this.state.data[rowIndex]['Part Number'] !== event.value) {
                    // force the event without validation happens when the cell is highlighted and they start typing
                    if (forced) {
                        data = this.state.data.map((item, i) => {
                            if (item['Part Number'] === inEditID) {
                                // need to add this so if validation is bad it can jump back to it since we forced bad data in
                                let lastValidValue = item['Part Number']
                                return { ...item, [event.field]: event.value, lastValidValue }
                            } else return item
                        })
                    } else {
                        let loadingData = initData
                        loadingData[rowIndex].loading = true
                        this.setState({ data: loadingData })
                        let loadedPart = await this.loadPart(event.value)
                        if (loadedPart) data[rowIndex] = loadedPart
                        else if (data[rowIndex].lastValidValue) {
                            data[rowIndex]['Part Number'] = data[rowIndex].lastValidValue
                        }
                        if (rowIndex === data.length - 1) {
                            data.push(App.getEmptyRow(this.props, this.state))
                        }
                    }
                }
            }
        } else {
            let maxLength = MAX_LENGTHS[event.field] || MAX_LENGTHS.ATTRIBUTE
            let maxLengthError = ''
            data = this.state.data.map((item) => {
                if (
                    item['Part Number'] === inEditID &&
                    event.value &&
                    event.value.length > maxLength
                ) {
                    maxLengthError += `Could not update column ${event.field} for ${item['Part Number']} because the value is too long\n`
                } else {
                    return item['Part Number'] === inEditID
                        ? { ...item, [event.field]: event.value }
                        : item
                }
                return item
            })
            maxLengthError.length > 0 && alert(maxLengthError)
        }
        let partNumbers = {}
        data.forEach((row) => (partNumbers[row['Part Number']] = true))
        if (data[data.length - 1]['Part Number'] !== '') {
            data.push(App.getEmptyRow(this.props, this.state))
        }
        data = data.map((row, i) => ({ ...row, index: i }))
        // keep the partNumbers accurate -- don't put unvalidated part numbers in
        if (!forced) this.setState({ data, partNumbers: partNumbers })
        else {
            this.setState({ data })
        }
        event.dataItem[event.field] = event.value
        this.props.partsRef.current.grid = data
        this.props.partsRef.current.changedParts[inEditID] = true
        this.setState({
            changes: true,
        })
    }
    pageChange = (event) => {
        let { dataState } = this.state
        dataState.skip = event.page.skip
        this.setState({
            dataState: { ...dataState },
        })
    }
}
